import { render, staticRenderFns } from "./EntityRelation.vue?vue&type=template&id=ce423116&lang=pug"
import script from "./EntityRelation.vue?vue&type=script&lang=js"
export * from "./EntityRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports